import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { Button, Col, Row } from 'react-bootstrap';

import { format } from 'date-fns';
import { FaPlusCircle, FaSpinner } from 'react-icons/fa';
import SelectSync from '../../../../components/SelectSync';
import InputFake from '../../../../components/InputFake';

import { Dente } from './styles';
import { useAgendamento } from '../../../../hooks/agendamento';
import {
  IProcedimento,
  IRetornoProcedimentoAssociado,
} from '../../../../components/Agendamento';
import { IOptions } from '../../../../utils/options';
import { useToast } from '../../../../hooks/toast';
import api from '../../../../services/api';
import { ITratamentoDente } from '..';
import { formatPrice } from '../../../../utils/funcoes';
import { Spinner } from '../../../../components/Agendamento/styles';
import Input from '../../../../components/Input';

// type WithChildren<T = {}> = T & { children?: React.ReactNode };

interface IFormDente {
  dente: string;
}

type Props = {
  pacienteID: number;
  AgeCodigo: number;
  agePlano: boolean;
  addTratamento(dados: ITratamentoDente): void;
  bloqueado: boolean;
};

const OdontoGrama = ({
  pacienteID,
  AgeCodigo,
  agePlano,
  addTratamento,
  bloqueado,
}: Props): JSX.Element => {
  const { buscaProcedimentos } = useAgendamento();
  const { addToast } = useToast();
  const formRefAdd = useRef<FormHandles>(null);

  const [procedimentos, setProcedimentos] = useState<IProcedimento[]>();
  const [optionsProcedimentos, setOptionsProcedimentos] = useState<IOptions[]>(
    [],
  );

  const [denteSelecionado, setDenteSelecionado] = useState<string | undefined>(
    undefined,
  );

  const [
    procedimentoSelecionado,
    setProcedimentoSelecionado,
  ] = useState<IProcedimento>();

  const [loadingProcedimento, setLoadingProcedimento] = useState(false);

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoadingProcedimento(true);
      try {
        const responseAgendamento = await api.get(
          `/agendamentos/${AgeCodigo}/detalhe`,
        );

        const responsePerfis = await api.get<number[]>(
          `/agendas/${responseAgendamento.data.AgeConfCodigo}/perfis`,
        );

        const respostaPro = await buscaProcedimentos(
          responsePerfis.data.join(','),
        );

        if (respostaPro) {
          setProcedimentos(respostaPro.procedimentos);
          setOptionsProcedimentos(respostaPro.optionsProcedimento);
        }
      } catch (error) {
        addToast({
          title: 'Não foi possível buscar o agendamento',
          type: 'error',
        });
      } finally {
        setLoadingProcedimento(false);
      }
    }
    if (AgeCodigo > 0 && !bloqueado) loadDados();
  }, [addToast, buscaProcedimentos, AgeCodigo, bloqueado]);

  const selecionaDente = useCallback((dente: string, tipo: string) => {
    setDenteSelecionado(dente);
    // setShowModalProcedimento(true);
  }, []);

  const handleProcedimentoChange = useCallback(
    ({ value, label }) => {
      // const ProCodigo = formRefAgendamento.current?.getFieldValue('procedimento');
      if (value) {
        const procedimento = procedimentos?.find(
          proced => proced.ProCodigo === Number(value),
        );
        setProcedimentoSelecionado(procedimento);
      } else {
        setProcedimentoSelecionado(undefined);
      }
    },
    [procedimentos],
  );

  useEffect(() => {
    if (denteSelecionado)
      formRefAdd.current?.setFieldValue('dente', denteSelecionado);
  }, [denteSelecionado]);

  const handleAddProcedimento = useCallback(async () => {
    if (!procedimentoSelecionado) {
      return;
    }
    let valorCobrado = agePlano
      ? procedimentoSelecionado.ProValorPlano
      : procedimentoSelecionado.ProValor;
    if (agePlano) {
      // verifica se agendamento ta ok com valor
      setLoadingProcedimento(true);
      try {
        const dataformatada = format(new Date(), 'yyyy-MM-dd');
        const response = await api.get<IRetornoProcedimentoAssociado[]>(
          `agendamentos/validaprocedimento?ProCodigo=${procedimentoSelecionado?.ProCodigo}&ProNome=${procedimentoSelecionado?.ProNome}&ProValor=${valorCobrado}&PacCodigo=${pacienteID}&AgeData=${dataformatada}`,
        );

        if (response.data.length !== 0) {
          valorCobrado = response.data[0].ProValor;
          addToast({
            type: 'info',
            title: 'Valor alterado pelo sistema',
            description: response.data[0].msg,
          });
        }
      } catch (error) {
        addToast({
          type: 'error',
          title: 'Erro ao buscar dados, tente novamente',
        });
        valorCobrado = -1;
      } finally {
        setLoadingProcedimento(false);
      }
      if (valorCobrado === -1) {
        return;
      }
    }
    addTratamento({
      dente: denteSelecionado || '',
      ProCodigo: procedimentoSelecionado.ProCodigo,
      ProNome: procedimentoSelecionado.ProNome,
      ProValor: valorCobrado,
      ProValorFormatado: formatPrice(valorCobrado),
      ProDuracao: procedimentoSelecionado.ProDuracao,
      chave: `${denteSelecionado}-${procedimentoSelecionado.ProCodigo.toString()}`,
    });

    setProcedimentoSelecionado(undefined);

    // const duracaoTotal = total.duracao + procedimentoSelecionado.ProDuracao;
    // if (formRefAgendamento && formRefAgendamento.current) {
    //   formRefAgendamento.current.setFieldValue(
    //     'duracaoTotal',
    //     duracaoTotal.toString(),
    //   );
    // }
  }, [
    addTratamento,
    procedimentoSelecionado,
    agePlano,
    pacienteID,
    denteSelecionado,
    addToast,
  ]);

  const exibeDentes = useCallback(
    (listaDentes: string[], tipo: string) => {
      const dentes = listaDentes.map(dente => {
        return (
          <button
            key={`dente-${dente}`}
            className={`btn ${tipo !== 'leite' ? 'p-0 border-0' : ''}`}
            data-toggle="popover"
            type="button"
            // dente="51"
            // lista="lista-proced-leite"
            onClick={() => selecionaDente(dente, tipo)}
            disabled={bloqueado}
          >
            {tipo === 'leite' ? dente : ''}
            {tipo !== 'leite' ? (
              <Dente
                className="dente"
                alt={`${tipo}-${dente}`}
                src={`https://agendadentista.med.br/Imagens/Dentes/${tipo}-${dente}.jpg`}
              />
            ) : (
              ''
            )}
          </button>
        );
      });
      return dentes;
    },
    [selecionaDente, bloqueado],
  );

  const handleSubmitAdd = useCallback(async (dados: IFormDente) => {
    console.log(dados);
  }, []);

  return (
    <>
      <Row>
        <Col lg={6} md={6} sm={12} className="text-right">
          <div className="btn-group">
            {exibeDentes(['55', '54', '53', '52', '51'], 'leite')}
          </div>
        </Col>
        <Col lg={6} md={6} sm={12} className="text-left">
          <div className="btn-group">
            {exibeDentes(['61', '62', '63', '64', '65'], 'leite')}
          </div>
        </Col>
      </Row>
      <Row className="small">
        <Col lg={6} md={6} sm={12} className="text-right">
          <div className="btn-group">
            {exibeDentes(
              ['18', '17', '16', '15', '14', '13', '12', '11'],
              'raiz',
            )}
          </div>

          <div className="btn-group">
            {exibeDentes(
              ['18', '17', '16', '15', '14', '13', '12', '11'],
              'dente',
            )}
          </div>
        </Col>

        <Col lg={6} md={6} sm={12} className="text-left">
          <div className="btn-group">
            {exibeDentes(
              ['21', '22', '23', '24', '25', '26', '27', '28'],
              'raiz',
            )}
          </div>

          <div className="btn-group">
            {exibeDentes(
              ['21', '22', '23', '24', '25', '26', '27', '28'],
              'dente',
            )}
          </div>
        </Col>
      </Row>
      <Row className="small">
        <Col lg={6} md={6} sm={12} className="text-right">
          <div className="btn-group">
            {exibeDentes(
              ['48', '47', '46', '45', '44', '43', '42', '41'],
              'dente',
            )}
          </div>
          <div className="btn-group">
            {exibeDentes(
              ['48', '47', '46', '45', '44', '43', '42', '41'],
              'raiz',
            )}
          </div>
        </Col>

        <Col lg={6} md={6} sm={12} className="text-left">
          <div className="btn-group">
            {exibeDentes(
              ['31', '32', '33', '34', '35', '36', '37', '38'],
              'dente',
            )}
          </div>
          <div className="btn-group">
            {exibeDentes(
              ['31', '32', '33', '34', '35', '36', '37', '38'],
              'raiz',
            )}
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={6} md={6} sm={12} className="text-right">
          <div className="btn-group">
            {exibeDentes(['88', '84', '83', '82', '81'], 'leite')}
          </div>
        </Col>
        <Col lg={6} md={6} sm={12} className="text-left">
          <div className="btn-group">
            {exibeDentes(['71', '72', '73', '74', '75'], 'leite')}
          </div>
        </Col>
      </Row>
      <div className="btn-group-sm p-1">
        <button
          key="dente---|--"
          className="btn mb-1 border-dark"
          data-toggle="popover"
          type="button"
          // dente="51"
          // lista="lista-proced-leite"
          onClick={() => selecionaDente('--|--', 'Semi Arcada')}
          disabled={bloqueado}
        >
          <Dente
            className="dente"
            alt="arcada---|--"
            src="https://agendadentista.med.br/Imagens/Dentes/dente-cruz.jpg"
          />
        </button>
        <button
          key="dente-Arcada Superior"
          className="btn btn-primary mb-1 ml-1"
          data-toggle="popover"
          type="button"
          // dente="51"
          // lista="lista-proced-leite"
          onClick={() => selecionaDente('Arcada Superior', '')}
          disabled={bloqueado}
        >
          Arcada Superior
        </button>
        <button
          key="dente-Arcada Inferior"
          className="btn btn-primary mb-1 ml-1"
          data-toggle="popover"
          type="button"
          // dente="51"
          // lista="lista-proced-leite"
          onClick={() => selecionaDente('Arcada Inferior', '')}
          disabled={bloqueado}
        >
          Arcada Inferior
        </button>
      </div>

      <div className={`p-1 ${bloqueado ? 'd-none' : ''}`}>
        <Form ref={formRefAdd} onSubmit={handleSubmitAdd}>
          <Row className="d-print-none">
            <Col md={2} lg={2}>
              <Input
                label="Dente"
                name="dente"
                onBlur={input => setDenteSelecionado(input.target.value)}
              />
            </Col>
            <Col md={8} lg={8}>
              <SelectSync
                name="procedimento"
                label="Procedimento"
                placeholder="Selecione"
                handleSelectChange={handleProcedimentoChange}
                options={optionsProcedimentos}
                isDisabled={!denteSelecionado || bloqueado}
              />
            </Col>
            <Col lg={2} md={2}>
              <Button
                type="button"
                style={{ marginTop: '21px' }}
                size="sm"
                variant="outline-info"
                onClick={() => handleAddProcedimento()}
                disabled={loadingProcedimento || !denteSelecionado || bloqueado}
              >
                {loadingProcedimento ? (
                  <Spinner>
                    <FaSpinner />
                  </Spinner>
                ) : (
                  <FaPlusCircle />
                )}
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default OdontoGrama;
